import { combineReducers } from "redux";
import createInvoiceReducer from "./createInvoice";

const reducers = combineReducers({
    createInvoice: createInvoiceReducer,
})

export default reducers;